/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import isCreditCardValidator from '../isCreditCard';
import isEmailUtill from '../isEmail';
import isEmptyUtill from '../isEmpty';
import { IsoCountryName } from '../types';
import unmaskPhoneNumber from '../unmaskPhoneNumber';

export type IsRequiredValue = number | string | null | Array<unknown> | Record<string, unknown>;

export const isRequired = (value: IsRequiredValue): boolean => {
  if (value === null || value === undefined) return false;
  if (Array.isArray(value)) return !!(value.length && value.length > 0);
  if (typeof value === 'object') return Object.keys(value).length > 0;
  if (typeof value === 'number') return !isEmptyUtill(`${value}`);
  return !isEmptyUtill(value);
};

export const isEmail = (value?: string) => (value ? isEmailUtill(value) : true);

export const isGmail = (value: string | null): boolean => {
  const pattern = /^[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+)*@gmail\.com$/;

  if (value === null || value === '') {
    return false;
  }
  const validGmailAddress = pattern.test(value);
  return validGmailAddress;
};

export const isZipCode = (isoCountryName?: string, value?: string) => {
  if (!value) return true;
  if (isoCountryName === IsoCountryName.US || isoCountryName === IsoCountryName.USA) {
    return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value);
  }
  if (isoCountryName === IsoCountryName.Canada) {
    return /^([a-z|A-Z][0-9][a-z|A-Z])\s*([0-9][a-z|A-Z][0-9])$/.test(value);
  }

  return value.length >= 3;
};

export const isCreditCard = (value?: string) => {
  return value ? isCreditCardValidator(value.replace(/[_ ]+/g, '')) : true;
};

export const isCVC = (value?: string) => (value ? value.replace(/[_ ]+/g, '').trim().length >= 3 : true);

export const streetAddress = (value?: string) => {
  if (!value) return true;
  const regex = /^\s*\S+(?:\s+\S+){2}/;
  if (regex.test(value)) {
    return true;
  }
  return false;
};

export const isPhoneNumber = (value?: string) => {
  if (value) {
    const unmaskedPhoneNumber = unmaskPhoneNumber(value).trim();
    if (unmaskedPhoneNumber.length >= 9 && unmaskedPhoneNumber.length <= 15) {
      return true;
    } else {
      return false;
    }
  }
  return true;
};

export const isPoBoxAddress = (value?: string) => {
  if (value) {
    const searcher = 'po box';
    const match = value.toLowerCase().search(searcher);
    return match === -1;
  }
  return true;
};
